:local(body) {
  --scrollbar-track-background: var(--neutral);
}

.staticLayout {
  max-width: 90rem;
  margin: 0 auto;

  .header {
    padding: 0 var(--padding);
  }

  .content {
    margin: 4.75rem auto 5rem;
    padding: 0 var(--padding);

    @media (min-width: 601px) {
      margin: 6rem auto 5rem;
    }

    @media (min-width: 769px) {
      margin: 7rem auto 7.5rem;
    }

    @media (min-width: 1281px) {
      margin: 8rem auto 7.5rem;
    }
  }
}
